import { APP_INITIALIZER, Injectable, Provider } from '@angular/core';
import { DisableDevtoolsService } from './disable-devtools.service';
import { first } from 'rxjs/operators';
import { DisableMediaSavingService } from './disable-media-saving.service';
import { DisableHotkeysService } from './disable-hotkeys.service';

@Injectable({
  providedIn: 'root',
})
export class SecurityInitializerService {
  private initialized = false;

  static provideAppInitializer(): Provider {
    return {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [SecurityInitializerService],
      useFactory: (initService: SecurityInitializerService) => {
        return () => initService.initialize();
      },
    };
  }

  constructor(
    private readonly disableHotkeysService: DisableHotkeysService,
    private readonly disableDevtoolsService: DisableDevtoolsService,
    private readonly disableMediaSavingService: DisableMediaSavingService,
  ) {}

  async initialize(): Promise<void> {
    if (this.initialized) {
      return;
    } else {
      this.initialized = true;
    }

    this.disableHotkeysService.initialize();
    this.disableDevtoolsService.initialize();
    this.disableMediaSavingService.initialize();

    await this.disableDevtoolsService.isInitialized$.pipe(first()).toPromise();

    return;
  }
}
